<script>
import api from '@/command/api'
import apiTool from '@/command/apiTool'
import DrawerForm from '../../../components/DrawerForm'
import TemplateHeaderTable from '../../../components/TemplateHeaderTable'
import { importAction } from '@/command/netTool'
export default {
  name: 'indexVoucherDetail',
  data() {
    return {
      ...api.command.getState(),
    }
  },
  mounted() {
    this.getInit()
  },
  methods: {
    getInit() {
      api.command.getList.call(this, {
        url: '/farmUserBalance/userBalanceRecordPage',
        current: 1,
        paramsValue: {
          userBalanceId: this.$route.query.id,
          status: 0
        },
      })
    },
    getHeader() {
      return []
    },
    getColumns() {
      return [
        {
          dataIndex: 'id',
          title: 'ID',
          align: 'left',
          sorter: (a, b) => a.id - b.id,
        },
        {
          dataIndex: 'createTime',
          title: '充值时间',
          align: 'left',
        },
        {
          dataIndex: 'amount',
          title: '充值金额',
          align: 'left',
          sorter: (a, b) => a.amount - b.amount,
        },
        {
          dataIndex: 'createByName',
          title: '操作人',
          align: 'left',
        },
      ]
    },
  },
  render() {
    return (
      <TemplateHeaderTable
        headerData={this.getHeader()}
        tableColumns={this.getColumns()}
        records={this.records}
      />
    )
  },
}
</script>
